export const buildVersion = {
  version: '1.4',
  buildNumber: 63,
  commit: '44d38a91c',
};
